const API_URL = 'https://rq180hf4vk.execute-api.us-east-2.amazonaws.com/dev/'
const API_KEY = '8zF_}d}d05QiB;peTOj[PHWu-/fLuw~('


// Get list of all videos
export const fetchVideos = async () => {
  const url = `${API_URL}/videos`
  const response = await fetch(url)
  const data = await response.json()

  return data
}

// Get a single video
export const fetchSingleVideo = async id => {
  const url = `${API_URL}/videos/${id}`
  const response = await fetch(url)
  const data = await response.json()

  return data
}

// Search video by tag/query
export const fetchVideosByTag = async tag => {
  const url = `${API_URL}/videos/tag/${tag}`
  const response = await fetch(url)
  const data = await response.json()

  return data
}

// Update views count for specified video
export const updateViewsCount = async videoId => {
  const url = `${API_URL}/view/${videoId}`
  const options = {
    method: 'POST',
    headers: {
      'x-api-key': API_KEY,
    },
  }

  const response = await fetch(url, options)
  const data = await response.json()

  return data
}


/**
 * Add a comment to the specified video
 *
 * @param {string|number} videoId
 * @param {string} username
 * @param {string} comment
 *
 * @returns {Promise<any>}
 */
export const addComment = async (videoId, username, comment) => {
  const url = `${API_URL}/comment/${videoId}`
  const body = {
    name: username,
    comment,
  }
  const options = {
    method: 'POST',
    headers: {
      'x-api-key': API_KEY,
    },
    body: JSON.stringify(body),
  }

  const response = await fetch(url, options)
  const data = await response.json()

  return data
}
